import { useState, useRef } from 'react';
import { TextField, Box, Button, Chip } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

interface FileItemFormProps {
  onDataChange: (data: { title: string; content: string; file?: File }) => void;
}

export default function FileItemForm({ onDataChange }: FileItemFormProps) {
  const [title, setTitle] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (selectedFile: File) => {
    setFile(selectedFile);
    const name = title || selectedFile.name;
    setTitle(name);
    onDataChange({ title: name, content: '', file: selectedFile });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="Title"
        value={title}
        onChange={(e) => {
          setTitle(e.target.value);
          onDataChange({ title: e.target.value, content: '', file: file ?? undefined });
        }}
        fullWidth
      />
      <input
        type="file"
        ref={fileInputRef}
        hidden
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) handleFileSelect(f);
        }}
      />
      <Button
        variant="outlined"
        startIcon={<CloudUploadIcon />}
        onClick={() => fileInputRef.current?.click()}
        sx={{ alignSelf: 'flex-start' }}
      >
        Choose file
      </Button>
      {file && (
        <Chip
          label={`${file.name} (${(file.size / 1024).toFixed(1)} KB)`}
          onDelete={() => {
            setFile(null);
            onDataChange({ title, content: '' });
          }}
        />
      )}
    </Box>
  );
}
